<script>
import * as m from '@app/paraglide/messages.js';
    /** @type {{eventIndex: any}} */
    let { event } = $props();

    function updateStyle(value) {
        event.style = value;
    }
</script>
<div class="mb-2">
    <select 
        id="caption-style-select" 
        aria-label={m.input_caption_style_aria_label()} 
        class="select-form form-control-sm rounded w-100 border-0" 
        title={m.input_caption_style_title()} 
        value={event?.style ?? "Pop-On"}
        onchange={(e) => updateStyle(e.currentTarget.value)}>
        <option selected="" value="Pop-On">{m.input_caption_style_pop_on()}</option>
        <option value="Roll-Up 2">{m.input_caption_style_roll_up_2()}</option>
        <option value="Roll-Up 3">{m.input_caption_style_roll_up_3()}</option>
        <option value="Roll-Up 4">{m.input_caption_style_roll_up_4()}</option>
        <option value="Paint-On">{m.input_caption_style_paint_on()}</option>
    </select>
</div>